import React from 'react';

export const createIconComp = ({ icon }: { icon: string; }) => {
  return (props: React.HTMLAttributes<HTMLDivElement>) => {
    const computStyle = Object.assign({}, { width: '28px', height: '28px' }, props.style || {});
    return <div {...props} style={computStyle} dangerouslySetInnerHTML={{ __html: icon }} />;
  };
};
